import { dateInputValue } from "../helpers";
import { inputCls } from "../input-class";

export function DateControl({
  id,
  value,
  disabled,
  onChange,
}: {
  id: string;
  value: string | null;
  disabled?: boolean;
  onChange: (next: string | null) => void;
}) {
  return (
    <input
      id={id}
      type="date"
      value={dateInputValue(value)}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value || null)}
      className={inputCls}
    />
  );
}
